import { render, staticRenderFns } from "./ManterProfissionalView.vue?vue&type=template&id=68f72f12"
import script from "./ManterProfissionalView.vue?vue&type=script&lang=js"
export * from "./ManterProfissionalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports